var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"setting__tips"},[_c('pd-icon',{attrs:{"icon":"tips-o"}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.parsedContent)},on:{"click":_vm.handleClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }